import iconSvg from './IconBookmarkSaved2.svg';

export const IconBookmarkSaved = props => <img src={iconSvg} alt="" {...props} />;
